import React from 'react'

const HomeAbout = () => {
  return (
    <div className='backdiv'>
      <div className='home-abtdiv'>
        <div>
        <h2 className='sapt-head'>ABOUT SAPTVEDA</h2>
        <p className='main-content'>Saptveda Ventures is the principal holding company of the Saptveda Group, operating across multiple business sectors. The group has established a strong presence in real estate consulting, portfolio management, construction, and financial services, offering integrated solutions under one roof through Saptveda Ventures Pvt. Ltd., Saptveda Constructions, and Saptveda Finance.<br/>Driven by expertise, transparency, and trust, Saptveda is committed to delivering value to its customers while contributing to society through initiatives like Saptveda Educations. With a balanced focus on business excellence and social responsibility, Saptveda continues to grow with a vision for sustainable impact.</p>
         <a href="/about-us"> <button className='svpl-btnss'>Read More</button></a>
    </div>
    <div className='home_abt_section'>
      <div>
      <div className='home_abtimg'>
 <video
                className='img-cover'
                src='./house_home.mp4' 
                autoPlay
                muted
                loop
                playsInline
              />
</div>
 <div className='home_abtimg2'>
</div>
</div>
    </div>
    </div>
   <a href="/about-us">   
    <div className='d-flex align-items-center justify-content-center'>
     <button className='svpl-btnss1'>Read More</button>
     </div></a>
    </div>
  )
}

export default HomeAbout